import type { ThreadId, ThreadKind } from "@cmmd-forge/contracts";

export interface WorkerBannerVisibilityInput {
  readonly kind: ThreadKind;
  readonly parentThreadId: ThreadId | null;
  readonly dismissed: boolean;
}

/**
 * Determines whether the worker-composer banner should be visible.
 * The banner appears only for worker threads with a known master, unless dismissed.
 */
export function deriveWorkerBannerVisibility(input: WorkerBannerVisibilityInput): boolean {
  return input.kind === "worker" && input.parentThreadId !== null && !input.dismissed;
}
